import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProductLookup from "common/productLookup";
import Button from "react-bootstrap/Button";
import { LookupModal } from "common/accountLookup";
import Modal from "common/modal";
import DataTable from "common/desktopDataTable";
import { searchSiteForProductUpdateHeaders } from "utils/common";
import isEmpty from "lodash/isEmpty";
import omitBy from "lodash/omitBy";
import axios from "services/config";
import { every } from "lodash";

const ProductToUpdated = ({ setSelectedProduct, selectedProduct, setSites, sites }) => {
  const navigate = useNavigate();
  const { storeCcn } = useSelector((state) => state.loggedInUser);
  const [accountData, setAccountData] = useState({});
  const [showProductLookupModal, setShowProductLookupModal] = useState(false);
  const [showAccountLookupModal, setShowAccountLookupModal] = useState(false);
  const [searchInProgress, setSearchInProgress] = useState(false);

  useEffect(() => {
    if (!isEmpty(selectedProduct)) {
      const { parentNumber, accountNumber } = accountData;
      const params = { storeNumber: storeCcn, accountNumber, salesNumber: selectedProduct.salesNumber, parentNumber };
      setSearchInProgress(true);
      setSites([]);
      axios(`/fc-site-repo/sites/bulkUpdateProductSearch?${new URLSearchParams(omitBy(params, isEmpty)).toString()}`)
        .then((res) => setSites((res.data ?? []).map((site) => ({ ...site, isSelected: true }))))
        .finally(() => setSearchInProgress(false));
    }
  }, [accountData, selectedProduct]);

  return (
    <div className="container-fluid product-tobe-updated mt-5">
      <div className="search-form-container__fields">
        <div className="search-form-container__fields__form">
          <div className="col-12 col-sm-12 col-md-6 col-lg-12 search-form-container__fields__form-group">
            <h4 className="">Step 1</h4>
            <p className="account-info__instruction px-0">
              Use the Product Lookup tool to select a product you wish to replace or add labor codes to on multiple
              sites for your store.
            </p>
            <div className="d-flex align-items-start my-2 px-5 py-3 border" style={{ width: "fit-content" }}>
              <Button
                variant="outline-primary"
                onClick={() => setShowProductLookupModal(true)}
                disabled={searchInProgress}
              >
                Product Lookup
              </Button>
              {showProductLookupModal && (
                <Modal
                  title="Select Product"
                  handleCancel={() => setShowProductLookupModal(false)}
                  size="xl"
                  closeButtonText="Cancel"
                  rootClass="add-product-modal"
                >
                  <ProductLookup
                    onProductSelectionCallback={(product) => {
                      setShowProductLookupModal(false);
                      setSelectedProduct(product);
                    }}
                    isPriceQuote={false}
                  />
                </Modal>
              )}
              {!isEmpty(selectedProduct) && (
                <>
                  <div className="d-flex flex-column mx-5">
                    <div style={{ fontWeight: 600 }}>Product Name</div>
                    <div>{selectedProduct?.productName}</div>
                  </div>
                  <div className="d-flex flex-column">
                    <div style={{ fontWeight: 600 }}>Sales Number</div>
                    <div>{selectedProduct?.salesNumber}</div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-lg-12 search-form-container__fields__form-group">
            <h4 className="">Step 2 (Optional)</h4>
            <p className="account-info__instruction px-0">
              Select an account to limit the update to only take place on sites assigned to the selected account. This
              step is optional. If you wish to update sites for your store regardless of their account, then skip this
              step.
            </p>
            <div className="d-flex align-items-start my-2 px-5 py-3 border" style={{ width: "fit-content" }}>
              <Button
                variant="outline-primary"
                onClick={() => (isEmpty(accountData) ? setShowAccountLookupModal(true) : setAccountData({}))}
                disabled={searchInProgress}
              >
                {isEmpty(accountData) ? "Account Lookup" : "Clear Account"}
              </Button>
              {showAccountLookupModal && (
                <LookupModal
                  onClose={() => setShowAccountLookupModal(false)}
                  onSelection={(data) => {
                    setShowAccountLookupModal(false);
                    setAccountData(data);
                  }}
                />
              )}
              {!isEmpty(accountData) && (
                <>
                  <div className="d-flex flex-column mx-5">
                    <div style={{ fontWeight: 600 }}>Account Name</div>
                    <div>{accountData?.accountName}</div>
                  </div>
                  <div className="d-flex flex-column">
                    <div style={{ fontWeight: 600 }}>Account Number</div>
                    <div>{accountData?.accountNumber}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-12 search-form-container__fields__form-group">
          <h4 className="">Step 3</h4>
          <p className="account-info__instruction px-0">
            Check the box next to each site you wish to update. Then select the Next button to proceed.
          </p>
        </div>
      </div>
      <div style={{ margin: "0px -32px" }}>
        <DataTable
          tableHeader={searchSiteForProductUpdateHeaders}
          tableBody={sites}
          countTitle="Search Results"
          displaySearchFilter={true}
          parentComponent="siteRepoBulkUpdate"
          isSelectAllChecked={!isEmpty(sites) && every(sites, "isSelected")}
          selectAllItems={(e) => {
            setSites(sites.map((site) => ({ ...site, isSelected: e.target.checked })));
          }}
          handleRowSelection={(row) => {
            setSites(
              sites.map((site) => (site.siteId === row.siteId ? { ...site, isSelected: !site.isSelected } : site)),
            );
          }}
          isLoading={searchInProgress}
        />
      </div>

      <div className="d-flex justify-content-end flex-column-reverse flex-md-row">
        <Button
          className="m-0"
          variant="primary"
          onClick={() => navigate(`/siteRepo/updateProducts#select-product-updated-from`)}
          disabled={!sites.some((site) => site.isSelected)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ProductToUpdated;
